export enum BarcodeBarRatioLevel {
    LevelPlus1 = 'LevelPlus1',
    Level0 = 'Level0',
    LevelMinus1 = 'LevelMinus1'
}